{
  "version": "v4.3.0",
  "name": "BitmapWordDeployer",
  "bytecode": "00014026010301040113d3c7309617b41301640c130164170217011600d1a2b316011602af1703160302",
  "codeHash": "082de32f22857e094db5658611a1d2ba23e792a7f23a548525e6de2784f2a70b",
  "fieldsSig": {
    "names": [],
    "types": [],
    "isMutable": []
  },
  "eventsSig": [],
  "functions": [
    {
      "name": "deploy",
      "paramNames": [
        "payer"
      ],
      "paramTypes": [
        "Address"
      ],
      "paramIsMutable": [
        false
      ],
      "returnTypes": [
        "BitmapWord"
      ]
    }
  ],
  "constants": [],
  "enums": []
}